import { LineChart } from 'bricks-ui/packages/bricks-ui';
export default LineChart;
